import React, { FC, ReactNode, RefObject, useCallback, useMemo } from 'react'
import { Helmet } from 'react-helmet'
import format from 'date-fns/format'
import styles from 'styles/components/layout.module.scss'
import { push } from 'connected-react-router'
import { Header } from 'components/Header'
import { Footer } from 'components/Footer'
import { BulkStockModal, CommonCautionModal, Modal, StockModal, StoreSwitchModal } from 'components/Modal'
import { useDispatch, useSelector } from 'react-redux'
import { State } from 'index'
import { CautionFixedLabel } from 'components/Label'
import { TopHeadline } from 'components/Typography'
import { SubHeader } from 'components/SubHeader'
import { getStoreTimesale } from 'reducks/storeTimesale/selectors'
import { StoreTimesale } from 'types/storeTimesale'

type Props = {
  customHeadline?: ReactNode
  headline?: string
  headlineSize?: 'small' | 'medium'
  iconPath?: string
  headingRef?: RefObject<HTMLHeadingElement>
  title: string
  children: ReactNode
}

const Layout: FC<Props> = (props) => {
  const { children, customHeadline, headline, headlineSize, headingRef, iconPath, title } = props
  const dispatch = useDispatch()
  const storeTimesale: StoreTimesale = useSelector((state: State) => getStoreTimesale(state))

  const timesaleEndDateTime = useMemo(() => {
    if (!storeTimesale) return null
    return format(storeTimesale.end_at.toDate(), 'MM月dd日 HH:mm')
  }, [storeTimesale])

  const moveToTimesale = useCallback(() => dispatch(push('/time_sale')), [dispatch])

  return (
    <>
      <Helmet>
        <title>{title} | sacri for owner</title>
      </Helmet>
      <Header headingRef={headingRef} />
      <SubHeader />
      <main className={styles.main}>
        {storeTimesale?.is_active && timesaleEndDateTime && (
          <CautionFixedLabel
            endIcon={'/icon/white/arrow_next.svg'}
            label={`タイムセール中 ${timesaleEndDateTime}まで`}
            onClick={moveToTimesale}
          />
        )}
        {customHeadline && customHeadline}
        {headline && <TopHeadline headline={headline} iconPath={iconPath} size={headlineSize} />}
        <section className={styles.section}>{children}</section>
      </main>
      <Footer />
      <Modal />
      <StockModal />
      <StoreSwitchModal />
      <CommonCautionModal />
      <BulkStockModal />
    </>
  )
}

export default Layout
